<template>
  <el-radio
    v-bind="$attrs"
    class="rt-radio"
    v-on="$listeners"
  >
    <slot />
  </el-radio>
</template>

<script>
import ElRadio from 'vue-xpc/src/element-ui/packages/radio/src/radio.vue';
export default {
  name: 'RtRadio',
  components: { ElRadio }
};
</script>



// WEBPACK FOOTER //
// rtRadio.vue?a3e0f692